import React from "react";
import { Helmet } from "react-helmet-async";
import { appUrl, getLogoURL } from "../../../constants/url-constants";
import PropTypes from "prop-types";

const SellUsedLuxuryMetaTags = ({
    metaTitle,
    metaDescription,
    ogTitle = "",
    ogDescription = ""
}) => {
    const baseUrl = `${appUrl()}/sell-used-luxury-cars/ `;

    return (
        <Helmet>
            <title>{metaTitle}</title>
            <meta name="title" content={metaTitle} />
            <meta name="description" content={metaDescription} />
            <meta name="ROBOTS" content="INDEX,FOLLOW" />
            <meta property="og:title" content={ogTitle} />
            <meta property="og:description" content={ogDescription} />
            <meta property="og:url" content={`${appUrl()}/`} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="CARS24" />
            <meta property="og:image" content={getLogoURL()} />
            <link href={`${baseUrl}`} rel="canonical" />
        </Helmet>
    );
};

SellUsedLuxuryMetaTags.propTypes = {
    metaTitle: PropTypes.string,
    metaDescription: PropTypes.string,
    ogTitle: PropTypes.string,
    ogDescription: PropTypes.string
};

export default SellUsedLuxuryMetaTags;
